import { useDropIdFromPath } from 'pages/Drops/useDropIdFromPath'
import { useDropDetailsPageStore } from 'store/context'

export const useDetailedDropById = () => {
  const dropId = useDropIdFromPath()
  return useDropDetailsPageStore(store => store.getDetailedDropById(dropId))
}
